import Typed from 'typed.js';

  //klescht (bangt/klatscht/knallt/fetzt. Als Wortwechsel durchschalten möglich?)
  const typed1 = new Typed('#typed1', {
    strings: ['klescht','bangt','klatscht','knallt','fetzt'],
    typeSpeed: 50,
    loop: true
  });